/**
 * Xác thực người dùng (qua BFF /api/auth/*). Session bằng cookie httpOnly.
 */
import { api } from './client';

/** Đăng nhập. Nếu tài khoản bật TOTP mà thiếu/sai code -> lỗi { totp_required }. */
export function login(username, password, code) {
  return api('/auth/login', { method: 'POST', json: { username, password, code } });
}

export function logout() {
  return api('/auth/logout', { method: 'POST' });
}

/** Lấy user hiện tại (401 nếu chưa đăng nhập). */
export function me() {
  return api('/auth/me');
}

// ── TOTP (Google Authenticator) ───────────────────────────────────────────────
/** Sinh secret mới (chưa bật). Trả { secret, otpauth_uri } để hiện QR. */
export function totpSetup() {
  return api('/auth/totp/setup', { method: 'POST' });
}
/** Bật TOTP sau khi xác nhận bằng 1 mã hợp lệ. */
export function totpEnable(code) {
  return api('/auth/totp/enable', { method: 'POST', json: { code } });
}
/** Tắt TOTP (cần nhập 1 mã hợp lệ). */
export function totpDisable(code) {
  return api('/auth/totp/disable', { method: 'POST', json: { code } });
}
